import React, { useEffect, useRef, useState, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

import { fetchOrganiserEvents } from "../redux/eventOrganiserThunks";
import userStore from "../../../zustand/userStore";
import * as XLSX from "xlsx";

import { UploadDocument } from "../../../configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
import axios from "axios";
import Popup from "../Popup";
const Upload = () => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const events = useSelector((state) => state.eventOrganiser.Events) || [];
  const navigate = useNavigate();
  const [selectedEventId, setSelectedEventId] = useState("");
  const [selectedActivityId, setSelectedActivityId] = useState("");
  const [activities, setActivities] = useState([]);
  const [fileInputs, setFileInputs] = useState([]);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (userData?.id) {
      dispatch(fetchOrganiserEvents({ userId: userData.id }));
    }
  }, [dispatch, userData]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newInputs = files.map((file) => ({
      file,
      description: "",
      category: "General",
    }));

    setFileInputs((prev) => [...prev, ...newInputs]);

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleEventChange = (e) => {
    const eventId = e.target.value;
    setSelectedEventId(eventId);

    const selected = events.find((ev) => ev.id.toString() === eventId);
    setActivities(selected?.activities || []);
  };

  const updateInputField = (index, key, value) => {
    setFileInputs((prev) => {
      const updated = [...prev];
      updated[index][key] = value;
      return updated;
    });
  };

  const removeFile = (indexToRemove) => {
    setFileInputs((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  // submit files
  const handleSubmit = async () => {
    if (!selectedEventId || !selectedActivityId || fileInputs.length === 0) {
      alert("Please select an event, activity, and upload files.");
      return;
    }

    if (window.confirm("Are you sure you want to submit these files?")) {
      const metadataArray = fileInputs.map((each) => {
        return {
          description: each.description,
          category: each.category,
          userId: userData?.id,
          // orgId: userData?.org?.id,
          activityId: Number(selectedActivityId),
          eventId: Number(selectedEventId),
        };
      });

      const formData = new FormData();

      fileInputs.forEach((each) => {
        formData.append("files", each.file);
      });

      formData.append("metadata", JSON.stringify(metadataArray));
      const headers = apiKeyHeader();
      delete headers["content-type"];
      try {
        console.log("frghjm,1");
        const response = await fetch(UploadDocument, {
          method: "POST",
          headers,
          body: formData,
        });
        if (response.ok) {
          const fetchedData = await response.json();
          alert(fetchedData?.message || "Files submitted successfully!");
          navigate("/uploadedDocuments");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const containerStyle = {
    // maxWidth: "900px",
    margin: "15px auto",
    padding: "15px 30px",
    backgroundColor: "rgb(123 47 247 / 51%)",
    // backgroundColor: "#ffffff",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: "12px",
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  };
  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container px-5">
        {/* <Sidebar />
        <Navbar /> */}
        <div className="right_col" role="main">
          <div className="x_panel" style={{ height: "80vh", overflow: "auto" }}>
            <div className="x_title">
              <button
                className="btn btn-primary btn-sm "
                onClick={() => window.history.back()}
              >
                <ArrowBackIcon style={{ cursor: "pointer" }} />
              </button>
              {/* <h2>
                
                
                Upload File(s) for the Event's Activity
              </h2>
              <div className="clearfix" /> */}
            </div>

            <div className=" " style={containerStyle}>
              <div className="">
                <label style={{ width: "120px" }}>
                  Select Event <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-control"
                  value={selectedEventId}
                  onChange={handleEventChange}
                >
                  <option value="">-- Select an Event --</option>
                  {events.map((ev) => (
                    <option key={ev.id} value={ev.id}>
                      {ev.name}
                    </option>
                  ))}
                </select>
              </div>

              {selectedEventId && (
                <div className="mt-3">
                  <label>
                    Select Activity <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={selectedActivityId}
                    onChange={(e) => setSelectedActivityId(e.target.value)}
                  >
                    <option value="">-- Select an Activity --</option>
                    {activities.map((act) => (
                      <option key={act.id} value={act.id}>
                        {act.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {selectedEventId && selectedActivityId && (
                <>
                  <div className=" mt-3">
                    <input
                      type="file"
                      multiple
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <FileUploadIcon style={{ marginRight: 8 }} />
                      Upload Files
                    </button>
                    {fileInputs.length > 0 && (
                      <p>
                        <strong>
                          {fileInputs.length}{" "}
                          {fileInputs?.length === 1 && "file"}
                          {fileInputs.length > 1 && "file (s)"} selected
                        </strong>
                      </p>
                    )}
                  </div>

                  {fileInputs.map((input, idx) => (
                    <div
                      key={idx}
                      className="mt-4 p-3 border rounded position-relative"
                      style={{ background: "#f9f9f9" }}
                    >
                      <CloseIcon
                        style={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "98%",
                        }}
                        onClick={() => removeFile(idx)}
                        title={"Remove"}
                      />
                      {/* <button
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: 10, right: 10 }}
                        onClick={() => removeFile(idx)}
                      >
                        Remove
                      </button> */}

                      <p>
                        <strong>File:</strong> {input.file.name}
                      </p>

                      <div className="row">
                        <div className="col-md-6">
                          <label>Description (optional)</label>
                          <input
                            type="text"
                            className="form-control"
                            value={input.description}
                            onChange={(e) =>
                              updateInputField(
                                idx,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                          />
                        </div>

                        <div
                          className="col-md-6"
                          style={{ paddingLeft: "10%" }}
                        >
                          <label>
                            Category <span style={{ color: "red" }}>* </span>
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`category-${idx}`}
                              value="General"
                              checked={input.category === "General"}
                              onChange={(e) =>
                                updateInputField(
                                  idx,
                                  "category",
                                  e.target.value
                                )
                              }
                            />
                            <label className="form-check-label">General</label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`category-${idx}`}
                              value="Quotations"
                              checked={input.category === "Quotations"}
                              onChange={(e) =>
                                updateInputField(
                                  idx,
                                  "category",
                                  e.target.value
                                )
                              }
                            />
                            <label className="form-check-label">
                              Quotations
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {fileInputs?.length > 0 && (
                    <div className="x_footer mt-4">
                      <button
                        className="btn btn-success"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </Suspense>
  );
};

const ViewUploadedDocuments = () => {
  const location = useLocation();
  const { state } = location;
  const { event, activity, files } = state || {};
  const [formData, setFormDataa] = useState({
    open: false,
    file: null,
  });
  const dataTableColumns = [
    { Header: "#", accessor: "sno" },
    { Header: "File Name", accessor: "file_name" },
    // { Header: "URL", accessor: "url" },
    { Header: "Description", accessor: "description" },
    { Header: "Category", accessor: "category" },
    { Header: "View", accessor: "action" },
  ];

  const processData = (eventsArray) => {
    let serial = 1;
    const rows = [];

    eventsArray.forEach((event) => {
      rows.push({
        sno: serial++,
        // url: event.url,
        file_name: event.name || "-",
        description: event.description || "-",
        category: event.category || "-",
        action: (
          <i
            title="View "
            className="fa fa-eye mx-2"
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => openDocument(event.url, event.name)}
            // onClick={() => window.open(`${event.url}`, "_blank")}
          ></i>
        ),
      });
    });

    return rows;
  };
  const openDocument = async (fileUrl, fileName) => {
    console.log("fileUrl", fileUrl);

    try {
      const url = fileUrl
        ? fileUrl.startsWith("https://web1024.docmaster.in:5010")
          ? fileUrl
          : fileUrl.replace(
              "http://localhost:5010",
              "https://web1024.docmaster.in:5010"
            )
        : "";

      const extension = fileName.split(".").pop().toLowerCase();

      let viewer = { type: "iframe", url: "" };

      // Excel
      if (extension === "xlsx" || extension === "xls") {
        const response = await axios.get(url, { responseType: "arraybuffer" });
        const data = new Uint8Array(response.data);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        let htmlContent = `<html><head><meta charset="UTF-8"><title>Excel Preview</title></head><body><table border="1" cellpadding="5" cellspacing="0">`;
        parsedData.forEach((row) => {
          htmlContent += "<tr>";
          row.forEach((cell) => {
            htmlContent += `<td>${cell ?? ""}</td>`;
          });
          htmlContent += "</tr>";
        });
        htmlContent += "</table></body></html>";

        const blob = new Blob([htmlContent], { type: "text/html" });
        const blobUrl = URL.createObjectURL(blob);
        viewer = { type: "iframe", url: blobUrl };
      }

      // Word/PPT
      else if (["doc", "docx", "ppt", "pptx"].includes(extension)) {
        const encodedUrl = encodeURIComponent(url);
        viewer = {
          type: "iframe",
          url: `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`,
        };
      }

      // PDF
      else if (extension === "pdf") {
        viewer = { type: "iframe", url };
      }

      // Images
      else if (
        ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)
      ) {
        viewer = { type: "image", url };
      }

      // Fallback
      else {
        window.open(url, "_blank");
        viewer = { type: "iframe", url };
      }

      // Set state after preparing viewer
      setFormDataa((prev) => ({
        ...prev,
        open: true,
        file: viewer.url,
      }));

      console.log("viewerUrl", viewer.url);

      return viewer;
    } catch (err) {
      console.error("Error in openDocument:", err);
      return { type: "iframe", url: "" };
    }
  };

  return (
    <div className="main_container px-5">
      {/* <Sidebar />
      <Navbar /> */}
      <div className="right_col" role="main">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div
              className="x_panel"
              style={{ overflow: "auto", height: "85vh" }}
            >
              {/* <div className="x_title">
                <div className="clearfix d-flex justify-content-between align-items-center">
                  <h2>
                    
                    View Uploaded Documents Details
                  </h2>
                </div>
              </div> */}
              <div style={{ display: "flex", gap: "20%" }}>
                <h2 style={{ fontSize: "14px" }}>
                  <button
                    onClick={() => window.history.back()}
                    className="btn btn-primary btn-sm"
                  >
                    <ArrowBackIcon style={{ cursor: "pointer" }} />
                  </button>{" "}
                  &nbsp; Event: <strong>{event}</strong>
                </h2>
                <h2 style={{ fontSize: "14px" }}>
                  Activity: <strong>{activity}</strong>
                </h2>
              </div>
              <div className="x_content">
                {files?.length > 0 ? (
                  <div className="table-responsive">
                    <AllFeatureDataTable
                      columns={dataTableColumns}
                      data={processData(files)}
                    />
                  </div>
                ) : (
                  <p>No Events Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {formData.open && (
        <Popup
          title={"Uploaded File"}
          minHeight="350px"
          maxWidth="800px"
          jsustifyContent="center"
          onClose={() =>
            setFormDataa((prev) => ({ ...prev, open: false, file: null }))
          }
        >
          <iframe
            src={formData.file}
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        </Popup>
      )}

      {/* <Footer /> */}
    </div>
  );
};

export { Upload, ViewUploadedDocuments };
